import { render, staticRenderFns } from "./wo002Detail01.vue?vue&type=template&id=0bfab4f0"
import script from "./wo002Detail01.vue?vue&type=script&lang=js"
export * from "./wo002Detail01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfab4f0')) {
      api.createRecord('0bfab4f0', component.options)
    } else {
      api.reload('0bfab4f0', component.options)
    }
    module.hot.accept("./wo002Detail01.vue?vue&type=template&id=0bfab4f0", function () {
      api.rerender('0bfab4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/imsi/sample/wo002Detail01.vue"
export default component.exports